import * as smoothscroll from "smoothscroll-polyfill";
import * as Animations from "./animations";
import "./referral.scss";

smoothscroll.polyfill();

document.addEventListener("DOMContentLoaded", () => {
  Animations.setupAnimations(["#corporate", "#fundamental", "#quant"]);
});
